import { Granularity } from "@/API";
import { IStat, Stat } from "@/entities";
import { ICustomerStatRepository } from "@/repositories";
import { ICustomerStatService } from ".";
import dayjs from "dayjs";

export class CustomerStatService implements ICustomerStatService {
    constructor(private repository: ICustomerStatRepository) { }

    async listAllStat(nextToken?: string): Promise<any | undefined> {
        return this.repository.listCustomerStatByGranularityWithTimestamp("ALL", undefined, nextToken);
    }

    async listDailyStat(inputDate: Date): Promise<Stat[] | undefined> {
        let list: Stat[] = [];
        if (!inputDate) {
            throw new Error("No inputDate parameter.");
        }

        const input = dayjs(inputDate);

        let temp: Stat[] = [];
        let token: string | undefined;
        do {
            const { items, nextToken } = await this.repository.listCustomerStatByGranularityWithTimestamp("DAILY", { eq: input.unix() }, token);
            if (items) {
                temp = [...temp, ...items];
            }
            token = nextToken;
        }
        while (token);
        list = [...list, ...temp];
        list = list.filter((l) => {
            if (l.id && l.id.length > 5) {
                return true;
            }
            return false;
        });
        console.log("listDailyStat", list);
        return list;
    }

    async listWeeklyStat(inputWeek: Date): Promise<Stat[] | undefined> {
        let list: Stat[] = [];
        if (!inputWeek) {
            throw new Error("No inputWeek parameter.");
        }

        const input = dayjs(inputWeek).startOf("week");

        let temp: Stat[] = [];
        let token: string | undefined;
        do {
            const { items, nextToken } = await this.repository.listCustomerStatByGranularityWithTimestamp("WEEKLY", { eq: input.unix() }, token);
            if (items) {
                temp = [...temp, ...items];
            }
            token = nextToken;
        }
        while (token);
        list = [...list, ...temp];
        list = list.filter((l) => {
            if (l.id && l.id.length > 5) {
                return true;
            }
            return false;
        });
        console.log("listWeeklyStat", list);
        return list;
    }

    async listMonthlyStat(inputMonth: Date): Promise<Stat[] | undefined> {
        let list: Stat[] = [];
        if (!inputMonth) {
            throw new Error("No inputMonth parameter.");
        }

        const input = dayjs(inputMonth);

        let temp: Stat[] = [];
        let token: string | undefined;
        do {
            const { items, nextToken } = await this.repository.listCustomerStatByGranularityWithTimestamp("MONTHLY", { eq: input.unix() }, token);
            if (items) {
                temp = [...temp, ...items];
            }
            token = nextToken;
        }
        while (token);
        list = [...list, ...temp];
        list = list.filter((l) => {
            if (l.id && l.id.length > 5) {
                return true;
            }
            return false;
        });
        console.log("listMonthlyStat", list);
        return list;
    }

    // async listDailyStat(id: string, from?: Date, to?: Date): Promise<Stat[] | undefined> {
    //     let token: string | undefined;
    //     let param = {};
    //     let list: Stat[] = [];

    //     if (from && to) {
    //         const fromDate = dayjs(from)
    //         const toDate = dayjs(to)
    //         // console.log(fromDate,toDate,fromDate.unix(), toDate.unix());
    //         param = {
    //             between: [{ granularity: Granularity.DAILY, timestamp: fromDate.unix() }, { granularity: Granularity.DAILY, timestamp: toDate.unix() }]
    //         }
    //         console.log("listDailyStat with filter", param);
    //     }

    //     do {
    //         const { items, nextToken } = await this.repository.getSaleStat(id, param, token)
    //         // console.log(items, nextToken);
    //         if (items) {
    //             const l = items.map((i: any) => new Stat(i));
    //             list = [...list, ...l];
    //         }
    //         token = nextToken;
    //     }
    //     while (token);

    //     // console.log(list);
    //     return list;
    // }

    // async listWeeklyStat(id: string, from?: Date, to?: Date): Promise<Stat[] | undefined> {
    //     let token: string | undefined;
    //     let param = {};
    //     let list: Stat[] = [];

    //     if (from && to) {
    //         const fromDate = dayjs(from).startOf("week");
    //         const toDate = dayjs(to).endOf("week");
    //         // console.log(fromDate,toDate,fromDate.unix(), toDate.unix());
    //         param = {
    //             between: [{ granularity: Granularity.WEEKLY, timestamp: fromDate.unix() }, { granularity: Granularity.WEEKLY, timestamp: toDate.unix() }]
    //         }
    //         console.log("listWeeklyStat with filter", param);
    //     }

    //     do {
    //         const { items, nextToken } = await this.repository.getSaleStat(id, param, token)
    //         // console.log(items, nextToken);
    //         if (items) {
    //             const l = items.map((i: any) => new Stat(i));
    //             list = [...list, ...l];
    //         }
    //         token = nextToken;
    //     }
    //     while (token);

    //     // console.log(list);
    //     return list;
    // }
    // async listMonthlyStat(id: string, from?: Date, to?: Date): Promise<Stat[] | undefined> {
    //     let token: string | undefined;
    //     let param = {};
    //     let list: Stat[] = [];

    //     if (from && to) {
    //         const fromDate = dayjs(from).startOf('month');
    //         const toDate = dayjs(to).endOf('month');
    //         // console.log(fromDate,toDate,fromDate.unix(), toDate.unix());
    //         param = {
    //             between: [{ granularity: Granularity.MONTHLY, timestamp: fromDate.unix() }, { granularity: Granularity.MONTHLY, timestamp: toDate.unix() }]
    //         }
    //         console.log("listMonthlyStat with filter", param);
    //     }

    //     do {
    //         const { items, nextToken } = await this.repository.getSaleStat(id, param, token)
    //         // console.log(items, nextToken);
    //         if (items) {
    //             const l = items.map((i: any) => new Stat(i));
    //             list = [...list, ...l];
    //         }
    //         token = nextToken;
    //     }
    //     while (token);

    //     // console.log(list);
    //     return list;
    // }

}